// extracted by mini-css-extract-plugin
export default {"wrapperText":"BimEditOtherCommon_wrapperText__9UxF9","leftBlock":"BimEditOtherCommon_leftBlock__wvkdZ"};